import { Link } from 'react-router-dom'
import { HugeiconsIcon } from '@hugeicons/react'
import {
  ArrowRight01Icon,
  BookOpen01Icon,
  UserGroupIcon,
  ArrowDown01Icon,
} from '@hugeicons/core-free-icons'
import { Button } from '@/components/ui/button'
import { BrandLogo } from '@/components/brand-logo'

export default function Landing() {
  return (
    <div className="brand-landing">
      <a href="#welcome" className="skip-link">
        Saltar al contenido
      </a>
      <header className="landing-header">
        <Link to="/" aria-label="St. George, inicio">
          <BrandLogo className="w-44 sm:w-56" />
        </Link>
        <nav
          aria-label="Navegación de bienvenida"
          className="flex items-center gap-5"
        >
          <a
            href="#tu-espacio"
            className="hidden text-sm font-medium hover:underline sm:block"
          >
            Tu espacio
          </a>
          <Button asChild variant="outline">
            <Link to="/login">
              Iniciar sesión
              <HugeiconsIcon icon={ArrowRight01Icon} data-icon="inline-end" />
            </Link>
          </Button>
        </nav>
      </header>
      <main id="welcome" tabIndex={-1}>
        <section className="landing-hero" aria-labelledby="welcome-title">
          <div className="landing-intro">
            <p className="brand-eyebrow">
              <span className="brand-dot" />
              COMUNIDAD ST. GEORGE
            </p>
            <h1 id="welcome-title">
              Un gran día
              <br />
              empieza <span>aquí.</span>
            </h1>
            <p className="landing-description">
              Más tiempo para enseñar. Más espacio para crecer. Organiza tu día
              y acompaña a tus estudiantes desde un mismo lugar.
            </p>
            <div className="flex flex-wrap items-center gap-4">
              <Button asChild size="lg">
                <Link to="/login">
                  Entrar a mi cuenta
                  <HugeiconsIcon
                    icon={ArrowRight01Icon}
                    data-icon="inline-end"
                  />
                </Link>
              </Button>
              <a
                href="#tu-espacio"
                className="inline-flex items-center gap-2 text-sm font-medium hover:underline"
              >
                Conoce tu espacio
                <HugeiconsIcon
                  icon={ArrowDown01Icon}
                  className="size-4"
                  aria-hidden="true"
                />
              </a>
            </div>
            <p className="landing-access-note">
              Acceso para administración y profesores.
            </p>
          </div>
          <div
            className="landing-art"
            aria-label="Aprender, enseñar y crecer en St. George"
          >
            <div className="landing-art-label">
              <span>ENGLISH SCHOOL</span>
              <span>ST. GEORGE</span>
            </div>
            <div className="landing-emblem">
              <img
                src="/brand/symbol-on-green.svg"
                width={67}
                height={48}
                alt=""
              />
            </div>
            <div className="landing-art-message">
              <span>Aprender.</span>
              <span>Enseñar.</span>
              <span>
                Crecer<span className="coral-period">.</span>
              </span>
            </div>
            <div className="landing-art-footer">
              <span>
                Conectamos personas
                <br />
                con nuevas oportunidades.
              </span>
              <HugeiconsIcon
                icon={ArrowRight01Icon}
                className="size-7"
                aria-hidden="true"
              />
            </div>
          </div>
        </section>
        <section
          id="tu-espacio"
          className="landing-spaces"
          aria-labelledby="spaces-title"
        >
          <div className="landing-section-heading">
            <p className="brand-eyebrow">TU DÍA, MÁS SIMPLE</p>
            <h2 id="spaces-title">Cada rol tiene su espacio.</h2>
            <p>
              Entra con tu cuenta. La plataforma te lleva a las herramientas que
              necesitas.
            </p>
          </div>
          <div className="landing-roles">
            <article className="landing-role">
              <div className="role-symbol">
                <HugeiconsIcon
                  icon={UserGroupIcon}
                  className="size-6"
                  aria-hidden="true"
                />
              </div>
              <div>
                <h3>Administración</h3>
                <p>
                  Registra estudiantes, organiza cursos y lleva las
                  inscripciones y los pagos al día.
                </p>
                <span>Estudiantes · Cursos · Facturación</span>
              </div>
              <span className="role-number" aria-hidden="true">
                01
              </span>
            </article>
            <article className="landing-role">
              <div className="role-symbol">
                <HugeiconsIcon
                  icon={BookOpen01Icon}
                  className="size-6"
                  aria-hidden="true"
                />
              </div>
              <div>
                <h3>Profesores</h3>
                <p>
                  Consulta tus clases, encuentra a tus estudiantes y registra la
                  asistencia desde Mi aula.
                </p>
                <span>Mis cursos · Mis estudiantes · Asistencia</span>
              </div>
              <span className="role-number" aria-hidden="true">
                02
              </span>
            </article>
          </div>
        </section>
        <section className="landing-help" aria-label="Ayuda para acceder">
          <div>
            <h2>¿Todo listo para empezar?</h2>
            <p>Usa el correo y la contraseña de tu cuenta de St. George.</p>
          </div>
          <Button asChild variant="outline">
            <Link to="/forgot-password">Recuperar mi contraseña</Link>
          </Button>
        </section>
      </main>
      <footer className="landing-footer">
        <span>St. George · English School</span>
        <span>
          © {new Date().getFullYear()} · Plataforma de gestión académica
        </span>
      </footer>
    </div>
  )
}
